import { componentConsumptionHooks } from "./store";
import { ObserverContext, observer } from "./signal";
export { signal, derived, effect, use, ObserverContext, SignalTracker, signalDebugHooks, } from "./signal";
export { useStore, createStoreProvider, cleanup } from "./store";
componentConsumptionHooks.onConsume = observer;
componentConsumptionHooks.onConsumed = () => {
    var _a;
    (_a = ObserverContext.current) === null || _a === void 0 ? void 0 : _a[Symbol.dispose]();
};
//# sourceMappingURL=index.js.map